export default async function getMenuData2() {
  return [
    {
      key: 'projects',
      icon: 'fe fe-file-text',
      url: '/contracts',
    },
  ]
}
